function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "raumobil/provider/homezone");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "raumobil/provider/homezone",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "HZ_Logo_weiss",
  transform: "translate(0.000000, 4.000000)",
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.4270677,8.0516041 C19.9578947,7.8882809 19.4345865,8.12419219 19.2721805,8.59601478 C19.1097744,9.06783737 19.3443609,9.59410102 19.8135338,9.75742423 C21.437594,10.3381289 22.1774436,11.0095688 22.1774436,11.4088033 C22.1774436,12.3524485 18.5864662,14.1852977 11.9819549,14.1852977 C5.37744361,14.1852977 1.78646617,12.3524485 1.78646617,11.4088033 C1.78646617,11.0277158 2.50827068,10.356276 4.11428571,9.77557125 C4.58345865,9.61224804 4.81804511,9.08598439 4.6556391,8.6141618 C4.49323308,8.14233921 3.96992481,7.90642792 3.50075188,8.06975112 C0.613533835,9.12227843 0,10.4651581 0,11.4088033 C0,14.421209 6.04511278,16 12,16 C17.9548872,16 24,14.421209 24,11.4088033 C24,10.4651581 23.3864662,9.10413141 20.4270677,8.0516041 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.91891892,12 L12.009009,12 C12.009009,12 12.009009,12 12.027027,12 L16.1171171,11.9652867 C16.6036036,11.9652867 17,11.5660837 17,11.097454 L17,4.6754924 C17,4.44985591 16.9099099,4.22421942 16.7297297,4.05065289 L12.7117117,0.249545871 C12.3693694,-0.0802305371 11.8108108,-0.0802305371 11.4684685,0.232189218 L7.28828829,4.05065289 C7.10810811,4.20686277 7,4.44985591 7,4.6754924 L7,11.1321673 C7.01801802,11.600797 7.41441441,12 7.91891892,12 Z M8.81981982,5.05733877 L12.0810811,2.0893511 L15.2162162,5.05733877 L15.2162162,10.246978 L12.009009,10.2643347 L8.81981982,10.2643347 L8.81981982,5.05733877 Z",
  id: "Shape"
})));

var SvgHomezone = function SvgHomezone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomezone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homezone.0ab0f91e.svg";
export { ForwardRef as ReactComponent };